import { Type } from 'class-transformer';
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { BoardApprovalActionsResultDto } from './board-approval-actions-result-dto';

export class BoardApprovalAccEditorResultDto {
    @Type(() => Date)
    dateSubmitted: Date;

    @Type(() => Date)
    dueDate: Date;

    noOfDays: number;
    proccessDisplayText: string;
    proccessHelpKey: string;
    proccessCurrentStatus: string;
    displayTextForUserSelection: string;
    allowUserSelection: boolean;

    @Type(() => KeyValueResultDto)
    onBehalfOf: Array<KeyValueResultDto>;

    notes: string;

    @Type(() => BoardApprovalActionsResultDto)
    actions: Array<BoardApprovalActionsResultDto>;

    customerId: string;
    existingResponseToCustomer: string;
}
